import { render } from "./ButtonStatus.vue?vue&type=template&id=01d56936&scoped=true&ts=true&lang=pug"
import script from "./ButtonStatus.vue?vue&type=script&lang=ts"
export * from "./ButtonStatus.vue?vue&type=script&lang=ts"

import "./ButtonStatus.vue?vue&type=style&index=0&id=01d56936&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d56936"]])

export default __exports__